export default __webpack_public_path__ + "static/media/10b.ee92145b.png";